import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { validate as uuidValidate } from 'uuid';
import { Link } from 'react-router-dom';
import {
  Button,
  Form,
  FormGroup,
  Input,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIgetFile } from '../api/Files';

import FileExtension from './File/Extension';
import FileResolution from './File/Resolution';
import FileSize from './File/Size';

import ErrorBoundary from './ErrorBoundary';

class FileSelectModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fileUuid: '',
      file: null,
      error: false,
      errorMessage: null,
      loading: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.handleSelectFile = this.handleSelectFile.bind(this);
    this.loadFile = this.loadFile.bind(this);
  }

  loadFile() {
    const { intl } = this.props;
    const { fileUuid } = this.state;

    if (!uuidValidate(fileUuid)) {
      this.setState({
        error: true,
        errorMessage: intl.formatMessage({
          defaultMessage: 'This UUID does not look valid',
        }),
      });
      return;
    }

    this.setState({
      loading: true,
      error: false,
      errorMessage: null,
    });

    APIgetFile(fileUuid).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({ file: data });
      }
      this.setState({ loading: false });
    }).catch(() => {
      this.setState({
        loading: false,
        error: true,
        errorMessage: intl.formatMessage({
          defaultMessage: 'File with this UUID does not exist',
        }),
      });
    });
  }

  handleChange(e) {
    const { value } = e.target;
    this.setState({ fileUuid: value });
  }

  handleEnter(e) {
    if (e.key === 'Enter') {
      this.loadFile();
    }
  }

  handleSelectFile() {
    const {
      handleSelectFile,
      handleClose,
    } = this.props;
    const { file } = this.state;

    handleSelectFile(file);
    handleClose();
  }

  render() {
    const { intl, handleClose } = this.props;
    const {
      fileUuid,
      file,
      error,
      errorMessage,
      loading,
    } = this.state;

    return (
      <ErrorBoundary>
        <ModalHeader toggle={handleClose}>
          Select file
        </ModalHeader>
        <ModalBody style={{ overflow: 'visible' }}>
          <Form className="file-select-form" onSubmit={(e) => { e.preventDefault(); }}>
            <FormGroup>
              <Input
                type="text"
                id="fileUuid"
                name="fileUuid"
                className="file-uuid"
                placeholder={intl.formatMessage({ defaultMessage: 'Enter file ID' })}
                disabled={loading}
                value={fileUuid}
                autoFocus={true}
                invalid={error}
                onChange={this.handleChange}
                onKeyUp={this.handleEnter}
              />
              <Button
                disabled={!fileUuid || loading}
                onClick={this.loadFile}
              >
                {loading ? (
                  <i className="far fa-spinner fa-spin" />
                ) : (
                  <i className="far fa-search" />
                )}
              </Button>
            </FormGroup>
            {error && (
              <div className="invalid-feedback">
                {errorMessage}
              </div>
            )}
          </Form>
          {file && (
            <div className="files-list">
              <div key={file.uuid} className="file-item">
                <Link to={`/files/${file.uuid}`} target="_blank" className="card-img">
                  <img
                    width="100%"
                    src={file.urls.thumbnail}
                    srcSet={`${file.urls.thumbnail} 1x, ${file.urls.thumbnailx2} 2x`}
                    alt={file.display_name}
                  />
                </Link>
                <div className="file-card-body">
                  <h5 className="file-title">
                    <Link to={`/files/${file.uuid}`} target="_blank" title={file.display_name}>
                      {file.display_name}
                    </Link>
                  </h5>
                  <div className="file-details">
                    <div>
                      <FileResolution
                        file={file}
                      />
                      <FileExtension
                        file={file}
                      />
                      <FileSize
                        file={file}
                      />
                    </div>
                  </div>
                </div>
                <div className="item-actions file-actions">
                  <Button color="primary" onClick={this.handleSelectFile}>
                    {intl.formatMessage({ defaultMessage: 'Select' })}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </ModalBody>
      </ErrorBoundary>
    );
  }
}

FileSelectModal.propTypes = {
  intl: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSelectFile: PropTypes.func.isRequired,
};

export default injectIntl(FileSelectModal);
